import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=730e371a&scoped=true&"
var script = {}
import style0 from "./emoji.vue?vue&type=style&index=0&id=730e371a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e371a",
  null
  
)

export default component.exports